import { useState, useEffect } from 'react';
import { useStore } from 'base/store';
import site from 'pro/config/site';
import { updateUrl } from 'ava-util/dist/request';
import { getUtmQuery, IUtmQuery } from 'base/utils/request';
import { displayCtr } from 'base/utils/tracker';
import { sharePopupModuleCode } from '@base/lib/share/utils';
import { getBatchLongToShortUrl } from 'base/servicesV2/share';
import { SHARE_CHANNELS_CONFIG } from '@base/lib/share/constant';
import { ILinkItem, IUrlsObj } from '@base/lib/share/interface';

type ISharePopupProps = {
    url?: string;
    utmQuery?: IUtmQuery;
    requireReferralCode?: boolean;
}

export type ISharePopupInstance = {
    isLoading: boolean;
    facebookUrl: string;
    xUrl: string;
    whatsappUrl: string;
    urlsObj: IUrlsObj;
    shortUrlsObj?: IUrlsObj;
    shortUrlsArray?: ILinkItem[]; // 传给 app
};

/**
 * 按 SHARE_CHANNELS_CONFIG 返回分享长连接
 * @param url
 * @param referralCode
 * @param utmQuery
 * @return IUrlsObj
 */
const getMergedQueryUrls = (url, referralCode, utmQuery): IUrlsObj => {
    let urls = {}
    SHARE_CHANNELS_CONFIG.map((linkConfig) => {
        urls[linkConfig.channel] = updateUrl(url, {
            refid: referralCode || void 0,
            ...utmQuery,
            utm_source: linkConfig.utmSource
        })
    })
    return urls as IUrlsObj
}

export function useSharePopup(props: ISharePopupProps): ISharePopupInstance {
    const {
        url: propsUrl,
        utmQuery: propsUtmQuery,
        requireReferralCode = false,
    } = props;
    const [clientUrl, setClientUrl] = useState<string>();
    const [shortUrlsData, setShortUrlData] = useState<{
        obj?: IUrlsObj,
        array: ILinkItem[];
    }>({
        obj: undefined,
        array: []
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const {
        rootStore: {
            state: { host, envName }
        },
        userStore: {
            state: {
                referralCode
            }
        }
    } = useStore();

    const utmQuery = getUtmQuery(referralCode, propsUtmQuery);

    let url = propsUrl || clientUrl || '/';
    if (!/^(http:|https:)*\/\//.test(url)) {
        const origin = envName !== 'dev' ? `https://${host}` : `https://${site.domain}`;
        url = origin + url;
    }

    const urlsObj = getMergedQueryUrls(url, referralCode, utmQuery)

    /**
     * 批量获取短链
     */
    const getShortShareUrls = async () => {
        try {
            setIsLoading(true)
            const _urls = SHARE_CHANNELS_CONFIG.map((item) => urlsObj[item.channel])
            const urlsRes = await getBatchLongToShortUrl(_urls)
            let _shortUrlList = urlsRes.urlList

            let urlObj = {}
            const shortUrls = SHARE_CHANNELS_CONFIG.map((item, index) => {
                const _link = _shortUrlList[index]
                const channel = item.channel

                urlObj[channel] = _link

                return {
                    type: channel,
                    link: _link
                }
            })

            setShortUrlData({
                obj: urlObj as IUrlsObj,
                array: shortUrls
            })

        } catch (e) {
            console.log({ e })
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (!propsUrl) {
            setClientUrl(window.location.href)
        }
    }, []);

    useEffect(() => {
        /*if (referralCode) {
            getShortShareUrls().then()
        }*/
        if (!requireReferralCode || (requireReferralCode && referralCode)) {
            getShortShareUrls().then()
            displayCtr(sharePopupModuleCode)
        }
    }, [referralCode]);

    return {
        isLoading: isLoading,
        urlsObj: urlsObj,
        shortUrlsArray: shortUrlsData.array,
        shortUrlsObj: shortUrlsData.obj,
        facebookUrl: `https://www.facebook.com/dialog/share?app_id=${site.facebook.appId}&display=popup&href=${
            encodeURIComponent(shortUrlsData.obj?.facebook || urlsObj.facebook)
        }`,
        xUrl: `https://twitter.com/intent/tweet?url=${
            encodeURIComponent(shortUrlsData.obj?.x || urlsObj.x)
        }`,
        whatsappUrl: `https://wa.me/?text=${
            encodeURIComponent(shortUrlsData.obj?.whatsapp || urlsObj.whatsapp)
        }`
    }
}